import { useEffect, useState } from "react";
import "./UserPage.css";
import "../Vocabularies/Crud/ResourceDetail.css";
import { useTranslation } from "react-i18next";
import { Spinner } from "../../components/Filtering/Reusable/Spinner";
import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import { toggleSection } from "../../utils/constants";
import DeleteButton from "../../components/buttons/DeleteButton";
import Swal from "sweetalert2";
import { useAuth } from "react-oidc-context";
import { jwtDecode } from "jwt-decode";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useWorkerApiHelper } from "../../hooks/useWorkerApiHelper";

function ArrowIcon({ open }) {
  return open ? (
    <KeyboardArrowUpIcon sx={{ ml: 1, fontSize: 22 }} aria-hidden />
  ) : (
    <KeyboardArrowDownIcon sx={{ ml: 1, fontSize: 22 }} aria-hidden />
  );
}

function ProfilePage() {
  const [isPersonalDataOpen, setIsPeronalDatalOpen] = useState(true);
  const [isAuthDataOpen, setIsAuthDataOpen] = useState(true);
  const [isContactDataOpen, setIsContactDataOpen] = useState(true);
  const { t, i18n } = useTranslation();
  const [loading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalMessage] = useState("");
  const { user } = useAuth();
  const { callApiWithWorker } = useWorkerApiHelper();

  const [userData, setUserData] = useState({
    id: "",
    name: "",
    firstSur: "",
    secondSur: "",
    organization: "",
    email: "",
    language: "",
    roles: [],
    awsZone: "",
    bucketName: "",
    department: "",
    phone: "",
    postal: "",
  });

  useEffect(() => {
    if (user) {
      try {
        const token = user?.access_token || user?.id_token || "";
        const decoded = jwtDecode(token);
        const roles = decoded.realm_access?.roles || [];
        setUserData({
          id: decoded.sub || "N/A",
          name: decoded.name || "N/A",
          firstSur: decoded.given_name || "N/A",
          secondSur: decoded.family_name || "N/A",
          organization: decoded.organization || "N/A",
          email: decoded.email || "N/A",
          department: decoded.department || "N/A",
          postal: decoded.postal || "N/A",
          phone: decoded.phone || "N/A",
          language: i18n.language || "N/A",
          roles: roles,
          userName: decoded.preferred_username || "",
        });
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, [user, i18n.language]);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const togglePersonalData = () =>
    toggleSection(setIsPeronalDatalOpen, ".profile-section-trigger--personal");
  const toggleAuthData = () =>
    toggleSection(setIsAuthDataOpen, ".profile-section-trigger--auth");
  const toggleContactData = () =>
    toggleSection(setIsContactDataOpen, ".profile-section-trigger--contact");

  const canDeleteAccount = () => {
    return userData.roles.includes("delete-account") || userData.roles;
  };

  const deleteRequest = async () => {
    try {
      const resp = await callApiWithWorker(
        `/keycloak/internal/delete/user?user=${encodeURIComponent(userData.id)}`,
        {
          method: "PUT",
          connector: "springConnector",
        },
      );
      const status =
        resp?.statusCode ??
        resp?.status ??
        resp?.data?.statusCode ??
        resp?.data?.status;

      if (
        (typeof resp?.ok === "boolean" && !resp.ok) ||
        (status && status >= 400)
      ) {
        throw new Error(`Delete user failed (${status ?? "unknown"})`);
      }

      if (!status || status === 200 || status === 204) {
        await Swal.fire({
          title: t("profilePage.deleteSuccessTitle"),
          text: t("profilePage.deleteSuccessMessage"),
          icon: "success",
          confirmButtonText: t("profilePage.okButton"),
        });
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      await Swal.fire({
        title: t("profilePage.deleteErrorTitle"),
        text: t("profilePage.deleteErrorMessage"),
        icon: "error",
        confirmButtonText: t("profilePage.okButton"),
      });
    }
  };

  const deleteAccount = async () => {
    if (!canDeleteAccount()) {
      await Swal.fire({
        title: t("profilePage.deleteNotAllowedTitle"),
        text: t("profilePage.deleteNotAllowedMessage"),
        icon: "error",
        confirmButtonText: t("profilePage.okButton"),
      });
      return;
    }

    const { isConfirmed } = await Swal.fire({
      title: t("profilePage.deleteTitle"),
      html: `
      <p>${t("profilePage.deleteFrontendMessage")}</p>`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: t("profilePage.ok"),
      cancelButtonText: t("createDataOfferingsDetail.cancel"),
    });

    if (isConfirmed) {
      deleteRequest();
    }
  };

  return (
    <section className="grisback profile-page">
      <div className="container containerflex profile-page-shell">
        <div className="w90 labeltittle profile-page-header">
          <h2 className="tittlecatalog">{t("profilePage.title")}</h2>
        </div>

        <div className="w90 bgwhite mtb2 profile-page-card">
          <div className="creatediv">
            <div className="profile-page-section">
              <div
                className="createdivgeneral w100 profile-section-trigger profile-section-trigger--personal"
                onClick={togglePersonalData}
                style={{ cursor: "pointer" }}
              >
                <h4 className="ptb3lr4">
                  {t("profilePage.personalData.title")}
                </h4>
                <ArrowIcon open={isPersonalDataOpen} />
              </div>
              {isPersonalDataOpen && (
                <div className="profile-page-fields">
                  <div className="profile-page-grid profile-page-grid--two">
                    <div className="profile-page-field">
                      <p className="ptitleinput">
                        {t("profilePage.personalData.name")}
                      </p>
                      <input
                        className="inputofferdisabled"
                        type="text"
                        value={userData.firstSur}
                        disabled
                      />
                    </div>
                    <div className="profile-page-field">
                      <p className="ptitleinput">{t("register.surname")}</p>
                      <input
                        className="inputofferdisabled"
                        type="text"
                        value={userData.secondSur}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              )}

              <div
                className="createdivdetails w100 profile-section-trigger profile-section-trigger--contact"
                onClick={toggleContactData}
                style={{ cursor: "pointer" }}
              >
                <h4 className="ptb3lr4">{t("profilePage.contact.title")}</h4>
                <ArrowIcon open={isContactDataOpen} />
              </div>
              {isContactDataOpen && (
                <div className="profile-page-fields">
                  <div className="profile-page-grid profile-page-grid--contact">
                    <div className="profile-page-field profile-page-field--wide">
                      <p className="ptitleinput">
                        {t("profilePage.personalData.organization")}
                      </p>
                      <input
                        className="inputofferdisabled"
                        type="text"
                        value={
                          userData.organization || t("organizationNotProvided")
                        }
                        disabled
                      />
                    </div>
                    <div className="profile-page-field profile-page-field--wide">
                      <p className="ptitleinput">
                        {t("profilePage.contact.department")}
                      </p>
                      <input
                        className="inputoffer"
                        type="text"
                        value={userData.department}
                        readOnly
                      />
                    </div>
                    <div className="profile-page-field profile-page-field--compact">
                      <p className="ptitleinput">
                        {t("profilePage.contact.phone")}
                      </p>
                      <input
                        className="inputoffer"
                        type="text"
                        value={userData.phone}
                        readOnly
                      />
                    </div>
                    <div className="profile-page-field profile-page-field--compact">
                      <p className="ptitleinput">
                        {t("profilePage.contact.postal")}
                      </p>
                      <input
                        className="inputoffer"
                        type="text"
                        value={userData.postal}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              )}
              <div
                className="createdivdetails w100 profile-section-trigger profile-section-trigger--auth"
                onClick={toggleAuthData}
                style={{ cursor: "pointer" }}
              >
                <h4 className="ptb3lr4">
                  {t("profilePage.authenticationData.title")}
                </h4>
                <ArrowIcon open={isAuthDataOpen} />
              </div>
              {isAuthDataOpen && (
                <div className="profile-page-fields">
                  <div className="profile-page-grid profile-page-grid--auth">
                    <div className="profile-page-field profile-page-field--wide profile-page-field--auth-email">
                      <p className="ptitleinput">
                        {t("profilePage.authenticationData.email")}
                      </p>
                      <input
                        className="inputoffer"
                        type="text"
                        value={userData.email}
                        readOnly
                      />
                    </div>
                    <div className="profile-page-field profile-page-actions">
                      {canDeleteAccount ? (
                        <DeleteButton
                          onClick={deleteAccount}
                          label={t("profilePage.deleteRequest")}
                        />
                      ) : (
                        <button
                          className="boton botoncancel"
                          disabled
                          style={{ cursor: "not-allowed", opacity: 0.6 }}
                          title={t("profilePage.deleteUnavailable")}
                        >
                          {t("profilePage.deleteUnavailable")}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="whiteback W100 p2">
        <div className="w90 flexdivbotones">
          <button className="boton botoncancel" onClick={() => navigate(-1)}>
            {t("createDataOfferingsDetail.cancel")}
          </button>

          <button
            type="submit"
            className="boton botoncapply"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? (
              <Spinner size="large" color="var(--main-color)" />
            ) : (
              t("profilePage.save")
            )}
          </button>
        </div>
      </div> */}

      <div>
        {loading && (
          <div className="loading">
            <Spinner size="large" color="var(--main-color)" />
          </div>
        )}
      </div>

      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogContent>{modalMessage}</DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>
            {t("profilePage.okButton")}
          </Button>
        </DialogActions>
      </Dialog>
    </section>
  );
}

export default ProfilePage;
